export const SERVICES = [
  {
    id: "online-restaurant",
    image:
      "https://images.unsplash.com/photo-1742281257707-0c7f7e5ca9c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBmb29kJTIwcmVzdGF1cmFudCUyMHRoYWxpfGVufDB8fHx8MTc4ODA3NTUxNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "online-coaching",
    image:
      "https://images.unsplash.com/photo-1600195077077-7c815f540a3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxib29rcyUyMGVkdWNhdGlvbiUyMHN0dWR5JTIwb25saW5lJTIwbGVhcm5pbmd8ZW58MHx8fHwxNzg4MDc1NTE1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "book-publishing",
    image:
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxib29rcyUyMGVkdWNhdGlvbiUyMHN0dWR5JTIwb25saW5lJTIwbGVhcm5pbmd8ZW58MHx8fHwxNzg4MDc1NTE1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "tours-travels",
    image:
      "https://images.unsplash.com/photo-1606298855672-3efb63017be8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxpbmRpYSUyMHRyYXZlbCUyMHRvdXJpc20lMjB0ZW1wbGV8ZW58MHx8fHwxNzg4MDc1NTE1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "contract-construction",
    image:
      "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwd29ya2VycyUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4ODA3NTUxNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "manpower-supply",
    image:
      "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwd29ya2VycyUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4ODA3NTUxNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "fire-fighting",
    image:
      "https://images.unsplash.com/photo-1625958936686-a9343dc35b5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxmaXJlJTIwZXh0aW5ndWlzaGVyJTIwZmlyZWZpZ2h0ZXIlMjBzYWZldHklMjBlcXVpcG1lbnR8ZW58MHx8fHwxNzg4MDc1ODkyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "trading-wholesale-retail",
    image:
      "https://images.unsplash.com/photo-1624137527136-66e631bdaa0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxvbmxpbmUlMjBzaG9wcGluZyUyMGVjb21tZXJjZSUyMGRlbGl2ZXJ5JTIwYm94ZXN8ZW58MHx8fHwxNzg4MDc1NTE1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "ecommerce",
    image:
      "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxvbmxpbmUlMjBzaG9wcGluZyUyMGVjb21tZXJjZSUyMGRlbGl2ZXJ5JTIwYm94ZXN8ZW58MHx8fHwxNzg4MDc1NTE1fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const PRODUCTS = [
  {
    id: "packaged-foods",
    serviceId: "ecommerce",
    priceInr: 99,
    image:
      "https://images.unsplash.com/photo-1546833999-b9f581a1996d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBmb29kJTIwcmVzdGF1cmFudCUyMHRoYWxpfGVufDB8fHx8MTc4ODA3NTUxNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "books-stationery",
    serviceId: "book-publishing",
    priceInr: 149,
    image:
      "https://images.unsplash.com/photo-1517673132405-a56a62b18caf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxib29rcyUyMGVkdWNhdGlvbiUyMHN0dWR5JTIwb25saW5lJTIwbGVhcm5pbmd8ZW58MHx8fHwxNzg4MDc1NTE1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "electrical-goods",
    serviceId: "trading-wholesale-retail",
    priceInr: 199,
    image:
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwd29ya2VycyUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4ODA3NTUxNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "safety-equipment",
    serviceId: "fire-fighting",
    priceInr: 499,
    image:
      "https://images.unsplash.com/photo-1496745109441-36ea45fed379?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxmaXJlJTIwZXh0aW5ndWlzaGVyJTIwZmlyZWZpZ2h0ZXIlMjBzYWZldHklMjBlcXVpcG1lbnR8ZW58MHx8fHwxNzg4MDc1ODkyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "construction-material",
    serviceId: "contract-construction",
    priceInr: 999,
    image:
      "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwd29ya2VycyUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4ODA3NTUxNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "household-essentials",
    serviceId: "trading-wholesale-retail",
    priceInr: 299,
    image:
      "https://images.unsplash.com/photo-1580674285054-bed31e145f59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxvbmxpbmUlMjBzaG9wcGluZyUyMGVjb21tZXJjZSUyMGRlbGl2ZXJ5JTIwYm94ZXN8ZW58MHx8fHwxNzg4MDc1NTE1fDA&ixlib=rb-4.1.0&q=85",
  },
];
